var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAttachment = function SvgIconAttachment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_2384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1007 4.18939L8.1007 13.1033C8.1007 14.8163 6.71324 16.2037 5.00023 16.2037C3.28721 16.2037 1.89975 14.8163 1.89975 13.1033L1.89975 3.41427C1.89975 2.34461 2.76788 1.47647 3.83755 1.47647C4.90721 1.47647 5.77535 2.34461 5.77535 3.41427L5.77535 11.553C5.77535 11.9793 5.42654 12.3281 5.00023 12.3281C4.57391 12.3281 4.22511 11.9793 4.22511 11.553L4.22511 4.18939L3.06243 4.18939L3.06243 11.553C3.06243 12.6227 3.93056 13.4908 5.00023 13.4908C6.06989 13.4908 6.93802 12.6227 6.93802 11.553L6.93802 3.41427C6.93802 1.70126 5.55056 0.313793 3.83755 0.313793C2.12453 0.313793 0.737067 1.70126 0.737068 3.41427L0.737068 13.1033C0.737068 15.4596 2.64386 17.3664 5.00023 17.3664C7.35659 17.3664 9.26338 15.4596 9.26338 13.1033L9.26338 4.18939L8.1007 4.18939Z",
    fill: "#24C3CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_2384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    fill: "white",
    transform: "translate(0 18) rotate(-90)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-attachment.097c0fffa372bebd703b55573e5306c0.svg";